'use client';

import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export type CarouselLoadingListProps = {
  type?: 'CAT' | 'PRODUCT' | 'BRAND';
};

const getHeight = (type: CarouselLoadingListProps['type']) => {
  switch (type) {
    case 'CAT':
      return 'h-[220px]';
    case 'BRAND':
      return 'h-[130px]';
    case 'PRODUCT':
    default:
      return 'h-[300px]';
  }
};

export const RecoCarouselLoadingList = ({ type }: CarouselLoadingListProps) => (
  <div className="grid auto-cols-[calc((100%-(var(--items-visible)-1)*var(--reco-gap))/var(--items-visible))] grid-flow-col gap-[var(--reco-gap)] gap-x-1.5 overflow-hidden [--items-visible:2.15] [--reco-gap:0.375rem] @xl:[--items-visible:3.5] @4xl:[--items-visible:4.5]">
    {Array.from({ length: 5 }).map((_, index) => (
      <Skeleton
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className={`${getHeight(type)} rounded-sm`}
      />
    ))}
  </div>
);
